import React from "react";
import { DEFAULT_BASE_MONEY_PROPS } from "./constants";
import { MoneyType } from "./types";
import { formatMoney } from "./utils";

type Props = {
  money: MoneyType | undefined | null;
  format?: MoneyFormat;
  rounded?: boolean; // whether to round to the nearest whole number
  suffix?: string;
  dashesAsDefault?: boolean;
};

// how to format a monetary amount as a string
export enum MoneyFormat {
  Symbol = "symbol", // currency symbol only
  SymbolAndCode = "symbol_and_currency_code", // with currency symbol and code
  SummaryWithCode = "summary_with_currency_code", // summary with currency code ie. USD 1T
  SummaryWithSymbol = "summary_with_symbol", // if < 1M: $999,999 else: $1.23M, $1.45B, $1.67T
  Summary = "summary", // 123.4 (b|m)illion if in the (b|m)illions, 123.4 thousand if in the hundreds of thousands
  Amount = "amount", // the amount only, ignores the currency symbol
}

const Money = ({
  money = DEFAULT_BASE_MONEY_PROPS,
  format = MoneyFormat.Symbol,
  rounded = true,
  suffix = "",
  dashesAsDefault = false,
}: Props) => {
  if (!money) {
    return dashesAsDefault ? <>--</> : null;
  }
  return (
    <>
      {formatMoney(money, format, rounded)}
      {suffix ? ` ${suffix}` : null}
    </>
  );
};

export type { MoneyType, Props as MoneyProps };
export default Money;
